import React, { useLayoutEffect } from 'react';
import {
  Content,
  ContentContainer,
  PageContainer,
  Title,
  BoldText,
  Text,
  StyledSubtitle,
  StyledCallToAction,
  StyledList,
  StyledLi,
} from './Hikes.styles';
import { useTranslation } from 'react-i18next';
// import PhotoGalleryDymin from './PhotoGalleryDymin'; // Jeśli masz galerię, albo usuń

export const Dymin = () => {
  const { t } = useTranslation();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const listItems = t('dymin.list1', { returnObjects: true }) as string[];

  return (
    <PageContainer>
      <ContentContainer>
        <Content>
          <Title>{t('hiking.dymin')}</Title>
          <BoldText>{t('hiking.destination-dymin')}</BoldText>
          <BoldText>{t('hiking.date-dymin')}</BoldText>
          <Text>{t('dymin.description')}</Text>
          <StyledSubtitle>{t('dymin.subtitle0')}</StyledSubtitle>
          <Text>{t('dymin.description0')}</Text>
          <StyledSubtitle>{t('dymin.subtitle1')}</StyledSubtitle>
          <Text>{t('dymin.description1')}</Text>
          <StyledList>
            {listItems.map((item: string, index: number) => (
              <StyledLi key={index}>
                <Content>{item}</Content>
              </StyledLi>
            ))}
          </StyledList>
          <StyledSubtitle>{t('dymin.subtitle2')}</StyledSubtitle>
          <Text>{t('dymin.description2')}</Text>
          <StyledSubtitle>{t('dymin.subtitle3')}</StyledSubtitle>
          <Text>{t('dymin.description3')}</Text>
          <StyledCallToAction>
            <StyledSubtitle>{t('dymin.cta')}</StyledSubtitle>
          </StyledCallToAction>
          <Text>{t('dymin.notice')}</Text>
          {/* <PhotoGalleryDymin /> Jeśli nie masz galerii, możesz to usunąć */}
        </Content>
      </ContentContainer>
    </PageContainer>
  );
};
